import { makeStyles, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import React, { useMemo, useState } from "react";
import ReactPlayer from "react-player/lazy";
import { useVimeoData, useYoutubeData } from "../hooks";

const useStyles = makeStyles(() => ({
  previewImageContainer: {
    width: "200px",
    position: "relative"
  },
  hiddenMediaPlayer: {
    display: "none"
  },
  previewImageDurationTag: {
    bottom: "10px",
    right: "4px",
    color: "#FFFFFF",
    float: "left",
    padding: "2px 5px",
    position: "absolute",
    fontWeight: "bold",
    borderRadius: "5px",
    backgroundColor: "#3e3e41"
  },
  previewImage: {
    borderRadius: "5px"
  }
}));

const VideoPreview = ({ imageWidth, videoUrl, thumbUrl, className }) => {
  const classes = useStyles();
  const [dur, setDur] = useState(undefined);

  // Try to fetch data from vimeo or youtube
  const vimeoVideoData = useVimeoData(videoUrl);
  const youtubeVideoData = useYoutubeData(videoUrl);
  const { imageUrl, duration } = isEmpty(vimeoVideoData?.imageUrl)
    ? youtubeVideoData
    : vimeoVideoData;

  if (duration && dur === undefined) {
    setDur(duration);
  }
  // Assign preview url
  const previewUrl = imageUrl || thumbUrl;

  const calculatedDuration = useMemo(
    () => `${`${Math.floor(dur / 60)}`.padStart(2, "0")}:${`${dur % 60}`.padStart(2, "0")}`,
    [dur]
  );

  const onReady = player => {
    setDur(player.getInternalPlayer().getDuration());
  };

  return (
    <div className={`${classes.previewImageContainer} ${className}`}>
      {videoUrl && (videoUrl.includes("youtube") || videoUrl.includes("youtu.be")) && (
        <div className={classes.hiddenMediaPlayer}>
          <ReactPlayer url={videoUrl} onReady={onReady} />
        </div>
      )}
      {dur && (
        <Typography variant="body2" className={classes.previewImageDurationTag}>
          {calculatedDuration}
        </Typography>
      )}
      <img className={classes.previewImage} alt="" width={imageWidth} src={previewUrl} />
    </div>
  );
};

export default VideoPreview;
